import React, { useState } from 'react';

const ROWS = [
  { band: 'restriction', color: 'rgba(220,38,38,0.70)', label: 'Avoid harvesting where possible' },
  { band: 'restriction', color: 'rgba(220,38,38,0.35)', label: 'Conservation priority / Use care' },
  { band: 'neutral',     color: '#e2e8f0',              label: 'No current local guidance' },
  { band: 'stewardship', color: 'rgba(22,163,74,0.35)', label: 'Generally stable' },
  { band: 'stewardship', color: 'rgba(22,163,74,0.70)', label: 'Good availability / Harvest focus' },
];

export default function StewardshipLegend({ showStewardship = true, showRestrictions = true }) {
  const [open, setOpen] = useState(true);

  const rows = ROWS.filter((r) => {
    if (r.band === 'restriction') return showRestrictions;
    if (r.band === 'stewardship') return showStewardship;
    return showStewardship;
  });

  return (
    <div style={{
      position: 'absolute', top: 10, right: 10, zIndex: 1000,
      background: 'rgba(255,255,255,.92)', borderRadius: 8,
      border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,.12)',
      minWidth: 180,
    }}>
      <div
        onClick={() => setOpen((o) => !o)}
        style={{ padding: '6px 12px', cursor: 'pointer', fontWeight: 700, fontSize: 12, color: '#334155', display: 'flex', justifyContent: 'space-between' }}
      >
        Stewardship guidance
        <span>{open ? '▲' : '▼'}</span>
      </div>
      {open && (
        <div style={{ padding: '4px 12px 10px' }}>
          {rows.map((r) => (
            <div key={r.label} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
              <div style={{ width: 16, height: 16, borderRadius: 3, background: r.color, flexShrink: 0, border: '1px solid rgba(0,0,0,.1)' }} />
              <span style={{ fontSize: 11, color: '#475569' }}>{r.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
